export const getCapitalizedFirstChar = (string: string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const booleanToString = (boolean: boolean) => {
  return boolean ? "Yes" : "No";
};

export const getCategoriesFromArray = (categories: string[]) => {
  return categories
    .map((category) => getCapitalizedFirstChar(category.replace("-", " ")))
    .join(", ");
};

export const getRemoveUrlNameFromField = (field: string) => {
  return "remove" + field.charAt(0).toUpperCase() + field.slice(1);
};
